<template>
  <preview-pane
    :loaded="loaded"
    :title="JobData && JobData.DisplayName ? JobData.DisplayName : null"
    :alertconfig="alertconfig">
    <!-- Job not found header template -->
    <template v-slot:header v-if="joberror">
      <v-toolbar dense flat class="minitoolbar">
        <v-spacer />
        {{ $t("servicesystem.common_objects.fallbackterms.no job_actions") }}
      </v-toolbar>
    </template>
    <!-- Job header template -->
    <template v-slot:header v-else>
      <v-toolbar dense flat class="minitoolbar">
        <v-spacer />
        <delete-job-btn :small="true" :textbtn="true"> </delete-job-btn>
        <approve-job-btn :small="true" :textbtn="true" class="ml-1 mr-2"> </approve-job-btn>
        <v-btn color="primary" small @click="open()">
          <v-icon class="mr-2" size="15" v-text="'open_in_full'" />
          {{ $t("servicesystem.common_objects.commonterms.open") }}
        </v-btn>
        <action-menu :actionList="actionlist" :parentcontext="thiscontext" class="ml-2"> </action-menu>
      </v-toolbar>
    </template>
    <!-- Job not found content template -->
    <template v-slot:content v-if="joberror">
      <empty-page
        :icon="'mdi-briefcase-remove'"
        :title="$t('servicesystem.common_objects.fallbackterms.no job')"
        :message="$t('servicesystem.common_objects.fallbackterms.failed_find_job', { jkey: $route.params.jobId })
          ">
      </empty-page>
    </template>
    <!-- Job content template -->
    <template v-slot:panels v-else>
      <section-header :title="$t('servicesystem.common_objects.customer.customer')" :notoppad="true">
      </section-header>
      <CustomerDetailsPreview :CustomerData="customerData" :loading="customerLoading"> </CustomerDetailsPreview>
      <CustomerAddressPreview :CustomerAddress="customerAddressData" :loading="customerAddressLoading">
      </CustomerAddressPreview>
      <CustomerContactPreview :CustomerContact="customerContactData" :loading="customerContactLoading">
      </CustomerContactPreview>
      <section-header :title="$t('servicesystem.common_objects.job.job')"></section-header>
      <ParentJobPreview :JobData="JobData" :loading="jobLoading"> </ParentJobPreview>
      <section-header :title="$t('servicesystem.common_objects.machine.machines')"></section-header>
      <template v-if="JobData && JobData.InverseParent && JobData.InverseParent[0]">
        <template v-for="subjob in JobData.InverseParent">
          <MachineJobPreview :key="subjob.Id" :MachineJobData="subjob" :loading="jobLoading">
          </MachineJobPreview>
        </template>
      </template>
      <v-container v-else-if="!jobLoading" fluid class="pa-0">
        {{ $t("servicesystem.common_objects.fallbackterms.no machines") }}
      </v-container>
      <section-header :title="$t('servicesystem.common_objects.appointment.appointments')">
        <template v-slot:button>
          <v-btn
            :disabled="JobData && JobData.JobStatusId >= 70"
            @click="
              $router.push({
                name: 'ViewJobPlanning',
                params: { filter: 'my', jobId: $route.params.jobId, appointmentId: 'new' }
              })
              "
            color="quaternary"
            class="white--text"
            small>{{ $t("servicesystem.common_objects.commonterms.new") }}</v-btn>
        </template>
      </section-header>
      <template v-if="JobData && JobData.Appointments && JobData.Appointments[0]">
        <appointments-preview :appointments="JobData.Appointments"> </appointments-preview>
      </template>
      <v-container v-else-if="!jobLoading" fluid class="pa-0">
        {{ $t("servicesystem.common_objects.fallbackterms.no appointments") }}
      </v-container>
    </template>
    <template v-slot:buttons>
      <v-btn @click="$store.state.triggerevents.previewCloseTrigger++" outlined color="close">{{
        $t("servicesystem.common_objects.commonterms.close") }}
      </v-btn>
      <v-btn @click="open()" color="primary">{{ $t("servicesystem.common_objects.commonterms.open") }} </v-btn>
    </template>
  </preview-pane>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ActionMenu from "@/components/Buttons/ActionMenu.vue";
import ApproveJobBtn from "@/components/Buttons/ApproveJobBtn.vue";
import DeleteJobBtn from "@/components/Buttons/DeleteJobBtn.vue";
import SectionHeader from "@/components/ExpancionPanels/Parts/SectionHeader.vue";
import AppointmentsPreview from "@/components/Preview/AppointmentsPreview.vue";
import CustomerAddressPreview from "@/components/Preview/Customer/CustomerAddressPreview.vue";
import CustomerContactPreview from "@/components/Preview/Customer/CustomerContactPreview.vue";
import CustomerDetailsPreview from "@/components/Preview/Customer/CustomerDetailsPreview.vue";
import MachineJobPreview from "@/components/Preview/MachineJobPreview.vue";
import ParentJobPreview from "@/components/Preview/ParentJobPreview.vue";
import EmptyPage from "@/components/Sections/EmptyPage.vue";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import AppointmentEditModel from "@/helpers/Models/Appointment-Edit-Model";
import CustomerContactEditModel from "@/helpers/Models/Customer-Contact-Edit-Model";
import CustomerEditModel from "@/helpers/Models/Customer-Edit-Model";
import DeliveryAddressEditModel from "@/helpers/Models/Delivery-Address-Edit-Model";
import ParentjobEditModel from "@/helpers/Models/Parentjob-Edit-Model";
import SubjobEditModel from "@/helpers/Models/Subjob-Edit-Model";
import PreviewPane from "@/views/layouts/PreviewPane.vue";

export default {
  name: "PreviewJob",
  components: {
    SectionHeader,
    //ExpandingObject,
    PreviewPane,
    ActionMenu,
    EmptyPage,
    DeleteJobBtn,
    ApproveJobBtn,
    CustomerDetailsPreview,
    CustomerAddressPreview,
    CustomerContactPreview,
    ParentJobPreview,
    MachineJobPreview,
    AppointmentsPreview
  },
  mixins: [clientAPI],

  data() {
    return {
      Cmodel: CustomerEditModel,
      CAmodel: DeliveryAddressEditModel,
      CCmodel: CustomerContactEditModel,
      PJmodel: ParentjobEditModel,
      SJmodel: SubjobEditModel,
      APmodel: AppointmentEditModel,
      JobData: null,
      customerData: null,
      customerAddressData: null,
      customerContactData: null,
      jobLoading: true,
      customerLoading: true,
      customerAddressLoading: true,
      customerContactLoading: true,
      thiscontext: this,
      actionlist: [
        {
          title: this.$t("servicesystem.common_objects.document.open_in_new_tab"),
          icon: "mdi-open-in-new",
          iconsize: 16,
          hovercolor: "primary",
          method: "openInNewTab"
        },
        {
          title: this.$t("servicesystem.common_objects.job.hazard_analysis"),
          icon: "mdi-file-alert",
          hovercolor: "primary",
          method: "gethazardanalysis"
        },
        {
          title: this.$t("servicesystem.common_objects.commonterms.service_report"),
          icon: "mdi-receipt-text",
          hovercolor: "secondary",
          method: "getservicereport"
        }
      ],
      joberror: false
    };
  },

  mounted() {
    this.getJob();
    this.$store.dispatch("NotificationStore/subscribe", [
      SRConst.EventKeys.JobChanged,
      this.test
    ]);
  },

  beforeDestroy() {
    this.$store.dispatch("NotificationStore/unsubscribe", [
      SRConst.EventKeys.JobChanged,
      this.test
    ]);
  },

  methods: {
    test(data) {
      if (this.JobData && this.JobData.Id == data.jobId) {
        this.getJob();
      }
    },

    async getJob() {
      this.jobLoading = true;
      this.customerLoading = true;
      this.customerAddressLoading = true;
      await this.getJobById(this.$route.params.jobId)
        .then(response => {
          this.joberror = false;
          this.JobData = response;
          this.$store.dispatch("JobHub/JobParentjob/setJobDetails", this.JobData, { root: true });
          this.customerData = this.JobData.Customer;
          this.customerAddressData = this.JobData.DeliveryAddress;
          if (this.customerAddressData) {
            if (!this.customerAddressData.Name) {
              this.JobData.DeliveryAddress.Name = this.$t(
                "servicesystem.common_objects.fallbackterms.unnamed_address"
              );
            }
          }
          this.$store.dispatch("JobHub/JobCustomer/setCustomer", this.JobData.Customer, { root: true });
          this.getCustomerContact();
        })
        .catch((/*error*/) => {
          this.joberror = true;
        })
        .finally(() => {
          this.jobLoading = false;
          this.customerLoading = false;
          this.customerAddressLoading = false;
          this.customerContactLoading = false;
        });
    },

    getCustomerContact() {
      this.customerContactLoading = true;
      this.getCustomerContactById(this.JobData.CustomerPersonId)
        .then(response => {
          this.customerContactData = response;
        })
        .catch((/*exception*/) => {
          this.customerContactData = false;
        })
        .finally(() => {
          this.customerContactLoading = false;
        });
    },

    open() {
      this.$router.push({ name: "ViewJob", params: { filter: "my", jobId: this.JobData.Id } });
    },

    openInNewTab() {
      let newPageRoute = this.$router.resolve({ name: "ViewJob", params: { filter: "my", jobId: this.JobData.Id } });
      window.open(newPageRoute.href, "_blank");
    },

    copyjob() {
      //TODO: add copy job method that also fetches the job first
    },

    gethazardanalysis() {
      this.GetHazardAnalysisLink(this.$route.params.jobId, true);
    },

    getservicereport() {
      this.GetServiceReportLink(this.$route.params.jobId, true);
    }
  },

  computed: {
    loaded() {
      var result = !this.jobLoading && !this.customerLoading && !this.customerContactLoading;
      return result;
    },

    alertconfig() {
      if (this.JobData) {
        var statusid = this.JobData.JobStatusId;
        if (statusid > 60) {
          if (statusid === 110) {
            return { color: "error", icon: "mdi-delete-empty", text: "servicesystem.common_objects.commonterms.deleted" }; //TODO: i18n key text
          } else if (statusid === 100) {
            return { color: "disabled", icon: "mdi-briefcase-off", text: "servicesystem.common_objects.commonterms.closed" };
          } else {
            return { color: "quaternary", icon: "mdi-check", text: "servicesystem.common_objects.commonterms.approved" };
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    JobPreviewPaneMode: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("JobPreviewPaneMode");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "JobPreviewPaneMode", value: update });
      }
    }
  },

  watch: {
    $route() {
      this.getJob();
    }
  }
};
</script>


<style scoped>
.minitoolbar {
  position: sticky;
  top: 0px;
  z-index: 10;
  box-shadow: 0px 1px 5px var(--v-header-darken2) !important;
}
</style>
